module.exports = __webpack_public_path__ + "static/media/status-rejected.451b6125.svg";